export default __webpack_public_path__ + "5a3954b9f419e0935d0c29bc82ddf8be.png";